import React from "react";

interface IProps {}

export const AnswersPage: React.FunctionComponent<IProps> = props => {
  return <div>AnswersPage</div>;
};
